import { authorizedAxios } from 'config/axios';

export const fetchFacts = () => {
  return authorizedAxios.get('/facts');
};
